<template>
  <section class="section-success">
    <img
      class="trebel-logo-redesign only-desk"
      :src="`${publicPath}assets/images/trebel_logo.png`"
      :alt="$t('TREBEL')"
    />
    <div class="container">
      <div
        v-if="$route.query.type === 'forgot'"
        class="section-success-inner mt-40 mb-40"
      >
        <h3 class="success-title">
          {{ $t("checkYourEmail") }}
        </h3>
        <p class="forgot-email-text">
          {{ $t("checkYourEmailText") }}
        </p>
        <b-img
          class="success-image"
          :src="`${publicPath}assets/images/success-forgot-password-image.png`"
          alt
        ></b-img>
        <p class="forgot-email-text">{{ $t("checkYourEmailFooterText") }}</p>
      </div>
      <div v-else class="section-success-inner">
        <h3 class="success-title">
          {{ $t("successfulReset") }}
        </h3>
        <p class="forgot-email-text">
          {{ $t("successfulResetText") }}
        </p>
        <b-img
          class="success-image"
          :src="`${publicPath}assets/images/success-reset-password-image.png`"
          alt
        ></b-img>
        <b-button variant="yellow" block class="btn-login">
          <a :href="getApp" class="go-app">
            {{ $t("goApp") }}
          </a>
        </b-button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Success",
  data() {
    return {
      // eslint-disable-next-line no-control-regex
      getApp:
        this.$route.query.type === "reset"
          ? "https://trebel.go.link/adj_link=trebel%3A%2F%2Fhome?adj_t=1hegjqqi_1hgky0s9&adj_campaign=reset_password&adj_deep_link=trebel%3A%2F%2Fhome"
          : `https://app.adjust.com/tue1xkd_7cmh9ov?campaign=TBD&adgroup=TBD&creative=TBD&deeplink=trebel://&fallback=${encodeURIComponent(
              "https://www.trebel.io/web/free"
            )}`
    };
  }
};
</script>
